export type ValueSupplier = (key: string) => unknown;

export class Cache {
  private valueFn: ValueSupplier;
  private cache: Record<string, unknown> = {};

  /**
   * Creates a new Cache.
   *
   * @param valueFn the value supplier function
   * @constructor
   */
  constructor(valueFn: ValueSupplier) {
    this.valueFn = valueFn;
    return this.clear();
  }

  /**
   * Clears any cached data.
   * @return the cache for method chaining
   */
  clear(): this {
    this.cache = {};
    return this;
  }

  /**
   * Evaluates the Caches's value supplier for the given key and caches the result.
   * @param key the key
   * @return the data for the key
   */
  store(key: string): unknown {
    const value = this.valueFn(key);
    this.cache[key] = value;
    return value;
  }

  /**
   * Returns the data for the given key using the value supplier if needed.
   *
   * @param key the key
   * @return the data for the key
   */
  get(key: string): unknown {
    return this.cache[key] || this.store(key);
  }
}
